// src/pages/Home.js
import React, { useState } from "react";
import rolls from "./assets/rolls.png";
import rollsBack from "./assets/roloR2.png";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import { useEffect } from "react";
import homecard1 from "./assets/homecards/1.jpg";
import homecard2 from "./assets/homecards/2.jpg";
import homecard3 from "./assets/homecards/3.jpg";
import homecard4 from "./assets/homecards/4.jpg";
import LinkedIn from "./assets/logo/LinkedIn.png";
import twitter from "./assets/logo/twitter.png";
import insta from "./assets/logo/insta.png";
import fb from "./assets/logo/fb.png";
import "./App.css"; // optional: copy styles here or import App.css
import { sendContactMessage } from "./services/authService";
import { toast } from "react-toastify";
import SEO from "./components/SEO";

function Home() {
  const [activeSlide, setActiveSlide] = useState(0);
  const [height, setHeight] = useState(window.innerHeight);
  const [userType, setUserType] = useState("");
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile_no: "",
    you_are: "",
    organization_name: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
const [showDriverMenu, setShowDriverMenu] = useState(false);
const[showSignupMenu, setShowSignupMenu] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // ✅ NAME → allow only letters & space
    if (name === "name") {
      const onlyText = value.replace(/[^A-Za-z ]/g, "");
      setFormData({ ...formData, name: onlyText });
      return;
    }

    // ✅ CONTACT → only numbers + max 10 digits
    if (name === "mobile_no") {
      const onlyNumbers = value.replace(/[^0-9]/g, "").slice(0, 10);
      setFormData({ ...formData, mobile_no: onlyNumbers });
      return;
    }

    // default
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const res = await sendContactMessage(formData);

      if (res.success === "1") {
        toast.success(res.message); // ✅ SUCCESS TOAST

        setFormData({
          name: "",
          email: "",
          mobile_no: "",
          you_are: "",
          organization_name: "",
          message: "",
        });
      } else {
        toast.error("Something went wrong"); // fallback
      }
    } catch (error) {
      console.error(error);

      toast.error(error?.message || "Failed to send message. Try again."); // ❌ ERROR TOAST
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const slides = [
    {
      image: homecard2,
      title: "Affordable cab fares across all ride types",
      subtitle:
        "Micro, Mini, Sedan, SUV, and Bike Taxi. Choose the perfect ride at the best price with Rolo Transit.",
    },
    {
      image: homecard1,
      title: "Get pick-drop rides, carpooling and fast deliveries",
      subtitle:
        "All in one easy cab booking app. Rolo Transit simplifies urban mobility with multiple services in a single platform.",
    },
    {
      image: homecard3,
      title: "Always Stay Safe",
      subtitle:
        "With real-time ride tracking, verified & trained drivers, and 24/7 emergency support. Rolo Transit ensures secure and reliable cab services for every trip.",
    },
    {
      image: homecard4,
      title: "Promoting Eco-Friendly Travel",
      subtitle:
        "Through carpooling and electric vehicle cabs. Rolo Transit supports greener, cleaner, and sustainable urban mobility.",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prevSlide) =>
        prevSlide === slides.length - 1 ? 0 : prevSlide + 1,
      );
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
     <>
      <SEO
        title="Rolo Transit | Safe, Reliable & Verified Cab Booking in Pune"
        description="Rolo Transit offers safe, affordable cab services in India offers pickup & drop, outstation,  & rental rides. Book Micro, Mini, Sedan, & Auto anytime with ease."
        keywords="cab service pune, rolo transit, taxi booking pune, outstation cabs pune, pickup and drop pune, car rentals pune, micro cab pune, mini cab pune, sedan cab pune"
        url="https://rolotransit.com/"
      />

   

      {/* page content */}
    
    <div className="App background" style={{ overflowX: "hidden" }}>
      {/* <img src={rollsBack} class="bg-image" alt=""></img> */}
      <div
        className="container-fluid pt-md-5 pb-md-5 mb-md-5"
        style={{ position: "relative", height: "100%" }}
      >
        <Navbar />
        <div id="square"></div>
        <div className="container-fluid pt-5">
          <div className="row align-items-center" style={{ minHeight: "80vh" }}>
            {/* Left Column */}
            <div className="col-12 col-md-7 mb-4 mb-md-0">
              <div className="ms-lg-5 text-center text-md-start">
                <h1
                  className="text-bold"
                  style={{
                    background:
                      "linear-gradient(90deg,rgba(255, 127, 31, 1) 0%, rgba(210, 90, 0, 1) 80%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  Ride The <br /> Vibe
                </h1>
                <p
                  className="pt-1 ps-1 fw-light"
                  style={{ color: "#898989ff", fontSize: "13px" }}
                >
                  {/* Revolutionizing urban and intercity mobility with safe, affordable, <br />
                                    and eco-friendly rides, deliveries, and more. Book now and experience <br />
                                    the future of transit! */}
                  Safe, affordable, and eco-friendly <br /> cab services for
                  local and intercity travel. <br /> Book your taxi with Rolo
                  Transit and <br /> enjoy fast, reliable, and comfortable{" "}
                  <br /> rides anytime.
                </p>
               <div className="position-relative d-inline-block">
  <button
    onClick={() => {
      setShowDownloadMenu(!showDownloadMenu);
      setShowDriverMenu(false);
    }}
    className="btn btn-md rounded-5 ps-4 pe-4 pt-3 pb-3 glass border-0 mt-3 text-decoration-none"
    style={{ color: "#d3d2d2ff", display: "inline-block" }}
  >
    <i className="fas fa-download me-2"></i>
    Download App
  </button>

  {showDownloadMenu && (
    <div
      className="position-absolute mt-2 p-2 rounded-4 shadow"
      style={{
        background: "#111",
        minWidth: "180px",
        zIndex: 999,
      }}
    >
      <a
        href="https://play.google.com/store/apps/details?id=com.rolo.rolocabsautobike"
        target="_blank"
        rel="noopener noreferrer"
        className="dropdown-item text-white py-2"
      >
         <i className="fab fa-android me-2 text-success"style={{fontSize: '22px'}}/>
        Android
      </a>

      <a
        href="https://apps.apple.com/in/app/rolo-cab-auto-bike/id6768391666"
        target="_blank"
        rel="noopener noreferrer"
        className="dropdown-item text-white py-2"
      >
          <i className="fab fa-apple me-2" style={{fontSize: '22px'}}/>
        iOS
      </a>
    </div>
  )}
</div>

<div className="position-relative d-inline-block ms-3">
  <button
    onClick={() => {
      setShowDriverMenu(!showDriverMenu);
      setShowDownloadMenu(false);
    }}
    className="btn btn-md rounded-5 ps-4 pe-4 pt-3 pb-3 glass2 border-0 mt-3 text-decoration-none"
    style={{ color: "#FC9344", display: "inline-block" }}
  >
    <i className="fas fa-car me-2"></i>
    Become a Driver
  </button>

  {showDriverMenu && (
    <div
      className="position-absolute mt-2 p-2 rounded-4 shadow"
      style={{
        background: "#111",
        minWidth: "180px",
        zIndex: 999,
      }}
    >
      <a
        href="https://play.google.com/store/apps/details?id=com.rolocabs"
        target="_blank"
        rel="noopener noreferrer"
        className="dropdown-item text-white py-2"
      >
           <i className="fab fa-android me-2 text-success"style={{fontSize: '22px'}}/>
        Android
      </a>

      <a
        href="IOS_DRIVER_LINK"
        target="_blank"
        rel="noopener noreferrer"
        className="dropdown-item text-white py-2"
      >
          <i className="fab fa-apple me-2" style={{fontSize: '22px'}}/>
        iOS
      </a>
    </div>
  )}
</div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-12 col-md-5">
              <div className="container">
                <div className="row justify-content-end me-lg-5 pe-lg-5 gx-0">
                  <div
                    className="w-100"
                    style={{ maxWidth: "500px", position: "relative" }}
                  >
                    {/* Fixed background layers outside slider */}
                    <div
                      className="slider-background-layers"
                      style={{
                        position: "absolute",
                        width: "85%",
                        height: "85%",
                        left: "7.5%",
                        bottom: "4%",
                        zIndex: 2,
                        pointerEvents: "none",
                      }}
                    >
                      {/* Second background layer */}
                      <div
                        style={{
                          position: "absolute",
                          width: "100%",
                          height: "100%",
                          backgroundColor: "#f7ba8c",
                          borderRadius: "40px",
                          transform: "rotate(12deg)",
                          transformOrigin: "left bottom",
                          bottom: "8px",
                          left: "8px",
                        }}
                      ></div>
                      {/* First background layer */}
                      <div
                        style={{
                          position: "absolute",
                          width: "100%",
                          height: "100%",
                          backgroundColor: "#FF7F1F",
                          borderRadius: "40px",
                          transform: "rotate(6deg)",
                          transformOrigin: "left bottom",
                          bottom: "4px",
                          left: "4px",
                        }}
                      ></div>
                    </div>
                    <div className="d-flex flex-column .responsive-glass">
                      <div
                        style={{
                          flexGrow: 1,
                          height: "600px",
                          marginTop: "50px",
                          position: "relative",
                          zIndex: 2,
                        }}
                      >
                        {slides.map((slide, index) => {
                          let rotate = "0deg";
                          let opacity = 0;

                          if (index === activeSlide) {
                            rotate = "0deg";
                            opacity = 1;
                          } else if (index > activeSlide) {
                            rotate = "6deg"; // Start at 6deg, animate to 0deg when appearing
                            opacity = 0;
                          } else {
                            rotate = "-6deg"; // Animate from 0deg to -6deg when disappearing (rotate left)
                            opacity = 0;
                          }

                          return (
                            <div
                              key={index}
                              className="d-flex flex-column"
                              style={{
                                position: "absolute",
                                width: "100%",
                                height: "100%",
                                top: 0,
                                left: 0,
                                opacity: opacity,
                                transform: `rotate(${rotate})`,
                                transformOrigin: "left bottom",
                                transition:
                                  "opacity 0.5s ease-in-out, transform 0.5s ease-in-out",
                                zIndex: activeSlide === index ? 3 : 1,
                                pointerEvents:
                                  activeSlide === index ? "auto" : "none",
                              }}
                            >
                              <div
                                style={{
                                  width: "85%",
                                  height: "95%",
                                  position: "relative",
                                  alignSelf: "center",
                                }}
                              >
                                {/* Image container */}
                                <div
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    position: "relative",
                                    overflow: "hidden",
                                    borderRadius: "40px",
                                  }}
                                >
                                  <img
                                    src={slide.image}
                                    alt="car"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      display: "block",
                                    }}
                                  />
                                  {/* Title and Subtitle Overlay */}
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      right: 0,
                                      background:
                                        "linear-gradient(to bottom, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)",
                                      padding: "20px 20px 30px 20px",
                                      borderRadius: "40px 40px 0 0",
                                    }}
                                  >
                                    <h4
                                      className="text-bold2"
                                      style={{
                                        color: "#fff",
                                        fontSize: "20px",
                                        marginBottom: "10px",
                                        lineHeight: "1.3",
                                      }}
                                    >
                                      {slide.title}
                                    </h4>
                                    <p
                                      className="fw-light"
                                      style={{
                                        color: "#fcfcfc",
                                        fontSize: "14px",
                                        lineHeight: "1.5",
                                        margin: 0,
                                      }}
                                    >
                                      {slide.subtitle}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Earn with Rolo Section */}
      <div className="container-fluid py-5 mt-5" id="earn">
        <br />
        <br />
        <br />
        <div className="row">
          <div className="col-12">
            <div className="text-center">
              <h2 className="text-bold">Earn with Rolo</h2>
              <p
                className="fw-light mb-0 text-center"
                style={{ color: "#898989ff", fontSize: "16px" }}
              >
                Start earning today! <br></br>
                Drive and earn on your own terms. Join the Rolo driver community
                and take advantage of flexible scheduling, <br></br> competitive compensation and supportive community that values your time and
                effort.
              </p>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10">
            <div
              className=" rounded-5 p-4 text-center"
              style={{ maxWidth: "100%" }}
            >
              <div className="row text-center">
                {/* <div className="col-6 col-md-2 mb-3">
                  <div className="text-center">
                    <i
                      className="fas fa-clock fa-2x mb-2"
                      style={{ color: "#d3d2d2ff" }}
                    ></i>
                    <p
                      className="fw-light"
                      style={{ color: "#898989ff", fontSize: "14px" }}
                    >
                      Flexible Hours
                    </p>
                  </div>
                </div>
                <div className="col-6 col-md-2 mb-3">
                  <div className="text-center">
                    <i
                      className="fas fa-dollar-sign fa-2x mb-2"
                      style={{ color: "#d3d2d2ff" }}
                    ></i>
                    <p
                      className="fw-light"
                      style={{ color: "#898989ff", fontSize: "14px" }}
                    >
                      Competitive Pay
                    </p>
                  </div>
                </div>
                <div className="col-6 col-md-2 mb-3">
                  <div className="text-center">
                    <i
                      className="fas fa-users fa-2x mb-2"
                      style={{ color: "#d3d2d2ff" }}
                    ></i>
                    <p
                      className="fw-light"
                      style={{ color: "#898989ff", fontSize: "14px" }}
                    >
                      Supportive Community
                    </p>
                  </div>
                </div>
                <div className="col-6 col-md-2 mb-3">
                  <div className="text-center">
                    <i
                      className="fas fa-user-plus fa-2x mb-2"
                      style={{ color: "#d3d2d2ff" }}
                    ></i>
                    <p
                      className="fw-light"
                      style={{ color: "#898989ff", fontSize: "14px" }}
                    >
                      Easy Registration
                    </p>
                  </div>
                </div>
                <div className="col-6 col-md-2 mb-3">
                  <div className="text-center">
                    <i
                      className="fas fa-file-alt fa-2x mb-2"
                      style={{ color: "#d3d2d2ff" }}
                    ></i>
                    <p
                      className="fw-light"
                      style={{ color: "#898989ff", fontSize: "14px" }}
                    >
                      Less Paperwork
                    </p>
                  </div>
                </div>
                <div className="col-6 col-md-2 mb-3">
                  <div className="text-center">
                    <i
                      className="fas fa-rocket fa-2x mb-2"
                      style={{ color: "#d3d2d2ff" }}
                    ></i>
                    <p
                      className="fw-light"
                      style={{ color: "#898989ff", fontSize: "14px" }}
                    >
                      Quick Approval
                    </p>
                  </div>
                </div> */}
              </div>
                      <section >
  

 <div className="earn-grid">
  {[
    "Flexible Hours",
    "Competitive Pay",
    "Supportive Community",
    "Easy Registration",
    "Less Paperwork",
    "Quick Approval"
  ].map((item, i) => (
    <div className="hex-wrapper" key={i}>
      <div className="hex-border">
        <div className="hex-content">
          
          <i
            className={`fas fa-${
              ["clock", "dollar-sign", "users", "user-plus", "file-alt", "rocket"][i]
            }`} style={{ fontSize: "45px",color: "#000000", borderRadius: "20%", padding: "10px" }} 
          ></i>

          <p>{item}</p> {/* ✅ FIXED */}

        </div>
      </div>
    </div>
  ))}
</div>
</section>
             

              <div className="position-relative d-inline-block ms-3">
  <button
    onClick={() => {
      setShowSignupMenu(!showSignupMenu);
      setShowDownloadMenu(false);
    }}
    className="btn btn-md rounded-5 ps-4 pe-4 pt-3 pb-3 glass2 border-0 mt-3 text-decoration-none"
    style={{ color: "#FC9344", display: "inline-block" }}
  >
   <i className="fas fa-male me-2"></i>Sign up as a Driver
  </button>

  {showSignupMenu && (
    <div
      className="position-absolute mt-2 p-2 rounded-4 shadow"
      style={{
        background: "#111",
        minWidth: "180px",
        zIndex: 999,
      }}
    >
      <a
        href="https://play.google.com/store/apps/details?id=com.rolocabs"
        target="_blank"
        rel="noopener noreferrer"
        className="dropdown-item text-white py-2"
      >
           <i className="fab fa-android me-2 text-success"style={{fontSize: '22px'}}/>
        Android
      </a>

      <a
        href="IOS_DRIVER_LINK"
        target="_blank"
        rel="noopener noreferrer"
        className="dropdown-item text-white py-2"
      >
          <i className="fab fa-apple me-2" style={{fontSize: '22px'}}/>
        iOS
      </a>
    </div>
  )}
</div>
            </div>
          </div>
        </div>

      </div>
      {/* Ride Information Section */}
      <div
        className="container-fluid py-5 mt-5 background2"
        style={{ color: "black" }}
      >
        <div className="row">
          <div className="col-12">
            <div className="text-center ps-5">
              <h3
                className="text-bold"
                style={{
                  fontSize: "40px",
                  background:
                    "linear-gradient(90deg,rgba(255, 127, 31, 1) 0%, rgba(210, 90, 0, 1) 80%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",

                  lineHeight: "50px",
                }}
              >
                Find the ideal ride for each journey!
              </h3>
              <p className="fw-light" style={{ fontSize: "16px" }}>
               Whether you’re heading across town or out of the city, Rolo Transit make sure about every trip of your's goes <br/>{" "}
smooth, safe, and effortless. 

              </p>
            </div>
          </div>
        </div>
        <div className="row mt-5 mx-5 text-white">
          <div className="col-12 col-md-3 mb-4 d-flex justify-content-center">
            <div
              className="rounded-4 p-3 h-100 text-center"
              style={{ backgroundColor: "#FF7F1F", width: "80%" }}
            >
              <i
                className="fas fa-car fa-2x mb-3 "
                style={{
                  color: "#D25A00",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "20%",
                  padding: "10px",
                }}
              ></i>
              <h4 className="text-bold2 mb-3">Lightning fast</h4>
              <p className="fw-light text-justify" style={{ fontSize: "14px" }}>
                 Simply tap, confirm, and go to find a ride in a matter of seconds. Thanks to our smart application, you are never far away from your next ride. Our app connects you with drivers in your area. 

              </p>
            </div>
          </div>
          <div className="col-12 col-md-3 mb-4 d-flex justify-content-center">
            <div
              className="rounded-4 p-3 h-100 text-center"
              style={{ backgroundColor: "#FF7F1F", width: "80%" }}
            >
              <i
                className="fas fa-shield-alt fa-2x mb-3"
                style={{
                  color: "#D25A00",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "20%",
                  padding: "10px",
                }}
              ></i>
              <h4 className="text-bold2 mb-3">Stay Safe on Every Ride </h4>
              <p className="fw-light text-justify" style={{ fontSize: "14px" }}>
                 Stay safe with real-time ride tracking, verified and trained drivers, and 24/7 emergency support. Rolo Transit ensures secure and reliable cab services for every trip. 
              </p>
            </div>
          </div>
          <div className="col-12 col-md-3 mb-4 d-flex justify-content-center">
            <div
              className="rounded-4 p-3 h-100 text-center"
              style={{ backgroundColor: "#FF7F1F", width: "80%" }}
            >
              <i
                className="fas fa-money-bill-alt fa-2x mb-3"
                style={{
                  color: "#D25A00",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "20%",
                  padding: "10px",
                }}
              ></i>
              <h4 className="text-bold2 mb-3">Easy Payment</h4>
              <p className="fw-light text-justify" style={{ fontSize: "14px" }}>
                Choose the payment option that works for you — cash, card, or digital wallet. Enjoy a simple and hassle-free payment experience every time 

              </p>
            </div>
          </div>
          <div className="col-12 col-md-3 mb-4 d-flex justify-content-center">
            <div
              className="rounded-4 p-3 h-100 text-center"
              style={{ backgroundColor: "#FF7F1F", width: "80%" }}
            >
              <i
                className="fas fa-credit-card fa-2x mb-3"
                style={{
                  color: "#D25A00",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "20%",
                  padding: "10px",
                }}
              ></i>
              <h4 className="text-bold2 mb-3">Safety Comes First</h4>
              <p
                className="fw-light text-justify"
                style={{ fontSize: "14px" }}
                id="business"
              >
                Ride with confidence with real-time tracking, verified drivers, and 24/7 support. Your safety remains a priority throughout every journey. 

              </p>
            </div>
          </div>
        </div>
      </div>

      <section
        className="glass2 py-5 rounded-0"
        style={{ maxWidth: "100%", color: "#ffffffb9" }}
      >
        <div className="row justify-content-center ">
          <div className="col-12 col-md-6 px-4 ">
            <div className="p-4">
              <h3
                className="text-bold"
                style={{
                  fontSize: "36px",
                  background:
                    "linear-gradient(90deg,rgba(255, 127, 31, 1) 0%, rgba(210, 90, 0, 1) 80%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  lineHeight: "30px",
                }}
              >
                {" "}
                BECOME OUR PARTNERS
              </h3>
              <div className="container mt-4">
                <div className="row align-items-start mb-3">
                  <div className="col-auto">
                    <i className="fas fa-globe"></i>
                  </div>
                  <div className="col">
                    <strong style={{ fontSize: "16px" }}>Address:</strong>
                    <br />
                    <span className="fw-light" style={{ fontSize: "16px" }}>
                      4th Floor, Netcheck house/ Pasalkar Chembers, <br /> Sr.
                      no. 6/10, 401 to 404, behind Indian oil, <br /> Ambegaon
                      Budruk, Pune, Maharashtra 411041
                    </span>
                  </div>
                </div>

                <div className="row align-items-start mb-3">
                  <div className="col-auto">
                    <i className="far fa-envelope fa-lg"></i>
                  </div>
                  <div className="col">
                    <strong style={{ fontSize: "16px" }}>
                      General Support
                    </strong>
                    <br />{" "}
                    <a
  href="mailto:support@rolotransit.com"
  className="fw-light"
  style={{ fontSize: "16px", color: "inherit", textDecoration: "none" }}
>
  support@rolotransit.com
</a>
                  </div>
                </div>

                <div className="row align-items-start mb-3">
                  <div className="col-auto">
                    <i className="fa fa-phone"></i>
                  </div>
                  <div className="col">
                    <strong style={{ fontSize: "16px" }}>Lets Talk:</strong>
                    <br />{" "}
                    <span className="fw-light" style={{ fontSize: "16px" }}>
                      +91-7507500300
                    </span>
                  </div>
                </div>

                <div className="d-flex gap-3 ">
                  <a
                    href="https://www.linkedin.com/company/rolo-transit-platforms-pvt-ltd/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "contain", // ✅ camelCase
                        transition: "0.3s", // ✅ string
                      }}
                      src={LinkedIn}
                      alt="LinkedIn"
                    />
                  </a>

                  <a
                    href="https://x.com/rolotransit?s=21"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "contain", // ✅ camelCase
                        transition: "0.3s", // ✅ string
                      }}
                      src={twitter}
                      alt="Twitter"
                    />
                  </a>

                  <a
                    href="https://www.instagram.com/rolotransit/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "contain", // ✅ camelCase
                        transition: "0.3s", // ✅ string
                      }}
                      src={insta}
                      alt="Instagram"
                    />
                  </a>

                  <a
                    href="https://www.facebook.com/rolotransit"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "contain", // ✅ camelCase
                        transition: "0.3s", // ✅ string
                      }}
                      src={fb}
                      alt="Facebook"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 px-4">
            <div className="p-4">
              <h3 className="mb-4" style={{ fontWeight: "bold" }}>
                Get in touch
              </h3>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label
                    htmlFor="name"
                    className="form-label"
                    style={{ fontWeight: "bold", fontSize: "14px" }}
                  >
                    *Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control custom-input"
                    placeholder="Your name"
                  
                    required
                    style={{
                      backgroundColor: "#ffffff31",
                      color: "#ffffff",
                      borderColor: "#ffffff42",
                   
                    }}
                  />
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label
                      className="form-label fw-bold"
                      style={{ fontWeight: "bold", fontSize: "14px" }}
                    >
                      *Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control custom-input"
                      placeholder="you@example.com"
                      required
                      style={{
                        backgroundColor: "#ffffff31",
                        color: "#ffffff",
                        borderColor: "#ffffff42",
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label
                      className="form-label fw-bold"
                      style={{ fontWeight: "bold", fontSize: "14px" }}
                    >
                      Contact Number
                    </label>
                    <input
                      type="text"
                      name="mobile_no"
                      value={formData.mobile_no}
                      onChange={handleChange}
                      className="form-control custom-input"
                      placeholder="+91-0000000000"
                      style={{
                        backgroundColor: "#ffffff31",
                        color: "#ffffff",
                        borderColor: "#ffffff42",
                      }}
                    />
                  </div>
                </div>

             <div className="mb-3">
  <label
    className="form-label fw-bold"
    style={{ fontWeight: "bold", fontSize: "14px" }}
  >
    *You are a
  </label>

 <select
  name="you_are"
  value={formData.you_are}
  onChange={handleChange}
  className="form-control"
  style={{
    backgroundColor: "#ffffff31",
    color: formData.you_are ? "#ffffff" : "#000000",
    borderColor: "#ffffff42",
  }}
>
  <option value="" style={{ color: "#000" }}>
    -Select-
  </option>

  <option value="Driver" style={{ color: "#000" }}>
    Driver
  </option>

  <option value="Individual" style={{ color: "#000" }}>
    Customer
  </option>

  <option value="Organization" style={{ color: "#000" }}>
    Organization
  </option>
</select>
</div>
                {formData.you_are === "Organization" && (
                  <div className="mb-3">
                    <label
                      className="form-label fw-bold"
                      style={{ fontWeight: "bold", fontSize: "14px" }}
                    >
                      *Organization Name
                    </label>
                    <input
                      type="text"
                      name="organization_name"
                      value={formData.organization_name}
                      onChange={handleChange}
                      className="form-control custom-input"
                      placeholder="Enter organization name"
                      required
                      style={{
                        backgroundColor: "#ffffff31",
                        color: "#ffffff",
                        borderColor: "#ffffff42",
                      }}
                    />
                  </div>
                )}

                <div className="mb-3">
                  <label
                    htmlFor="message"
                    className="form-label"
                    style={{ fontWeight: "bold", fontSize: "14px" }}
                  >
                    *Message
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control custom-input"
                    rows="4"
                    placeholder="Your message..."
                    required
                    style={{
                      backgroundColor: "#ffffff31",
                      color: "#ffffff",
                      borderColor: "#ffffff42",
                    }}
                  />
                </div>

                <div className="mb-3">
                  <button
                    type="submit"
                    className="btn btn-dark rounded-pill py-2"
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <style>{`
      /* SECTION */

.custom-input {
  color: #ffffff !important;
}

.custom-input::placeholder {
  color: #000000 !important;
  opacity: 1;
}


/* GRID */
.earn-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-items: center;
   
  max-width: 700px;
  margin: auto;
}

/* PERFECT HONEYCOMB OFFSET */
.earn-grid .hex-wrapper:nth-child(4),
.earn-grid .hex-wrapper:nth-child(5),
.earn-grid .hex-wrapper:nth-child(6) {
  transform: translate(110px, -30px); 
}

/* HEX WRAPPER */
.hex-wrapper {
  width: 220px;
  height: 240px;
  position: relative;
  transform: translateY(10px); /* reduce vertical space */
}

/* OUTER HEX (ORANGE FRAME) */
.hex-border {
  position: relative;
  width: 100%;
  height: 100%;
  background: #a0a9aa;

  clip-path: polygon(
    50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%
  );

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 1;
}

.hex-border::before {
  content: "";
  position: absolute;
  inset: 0;

  background: #d96f1c;

  /* 🔥 ONLY RIGHT + BOTTOM SIDES */
  clip-path: polygon(
    95% 25%,   /* right top */
    100% 50%,
    95% 75%,   /* right bottom */
    50% 100%,  /* bottom */
    40% 90%,
    85% 70%,
    85% 30%,
    40% 10%
  );

  transform: translate(10px, 10px);

  z-index: -1;
}
 .hex-border::after {
  content: "";
  position: absolute;
  inset: 0;

  background: rgba(0,0,0,0.25);

  clip-path: inherit;

  transform: translate(18px, 18px);

  filter: blur(6px); /* 🔥 IMPORTANT */

  z-index: -2;
}
/* INNER WHITE HEX */
.hex-content {
  width: 80%;
  height: 80%;
  background: #F5F5F5;

  clip-path: inherit;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 18px;
  text-align: center;

  /* subtle inner depth */
  box-shadow: inset 0 6px 12px rgba(0,0,0,0.08);
}

/* ICON */
.hex-content i {
  width: 55px;
  height: 55px;
  margin-bottom: 12px;
}

/* TEXT */
.hex-content p {
  font-size: 16px;
  font-weight: 700;
  color: #D86100;
  line-height: 1.3;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .earn-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .earn-grid .hex-wrapper:nth-child(4),
  .earn-grid .hex-wrapper:nth-child(5),
  .earn-grid .hex-wrapper:nth-child(6) {
    transform: none;
  }
}

@media (max-width: 480px) {
  .earn-grid {
    grid-template-columns: 1fr;
  }
}`}</style>
    </div>
    </>
  );
}

export default Home;
